import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import { useForm, Controller } from "react-hook-form";
import { z } from "utils/zod-pt";
import { zodResolver } from "@hookform/resolvers/zod";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import { customTheme } from "styles/CustomField";
import CustomLabel from "components/Label";
import * as palette from "styles/variables";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { IconButton, InputAdornment } from '@mui/material';
import { CircularProgress } from "@mui/material";
import attention from "assets/icons/attention.svg"
import { set } from "date-fns";

const style = {
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 650,
  bgcolor: palette.lightBackground,
  borderRadius: "5px",
  p: 4,
};

export default function ModalMinorToResp({ open, handleClose, onSubmit, isLoading}) {

  const CustomButton = ({ text, color, hoverColor, onClick, type}) => (
    <Button
      variant="contained"
      onClick={onClick}
      sx={{
        backgroundColor: color,
        color: '#FFFFFF',
        marginRight: 3,
        textTransform: 'none',
        fontWeight: 'bold',
        fontSize: '1.1em',
        '&:hover': {
          backgroundColor: hoverColor,
        },
        minWidth: '40%',
        height: '30%'
      }}
      startIcon={isLoading && type==='submit' && <CircularProgress sx={{marginLeft: 1}} color="inherit" size="1.2rem" />}

    >
      {text}
    </Button>
  );

  const handleCancel = () => {
    handleClose()
    // window.location.reload()
  }
  const outerTheme = useTheme();
  return (
    <ThemeProvider theme={customTheme(outerTheme)}>
      <div>
        <Modal
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"

        >
          <Box sx={style}>
            {/* Cabeçalho */}
            <div
              onClick={handleCancel}
              style={{ marginLeft: "auto", cursor: "pointer" }}
            >
              <CloseIcon />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: 'column',
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                gap: 5
              }}
            >
              <img src={attention} alt="" />
              <Typography
                variant="h5"
                component="h2"
                style={{
                  textAlign: 'center',
                  color: palette.darkPreto,
                  fontFamily: "Poppins",
                }}
              >
                Tem certeza que deseja tornar a gestante menor como responsável do benefício?
              </Typography>
              {/* <p
                style={{
                  textAlign: 'center',
                  color: palette.darkPreto,
                  fontFamily: "Poppins",
                  width: '80%',
                  fontSize: '0.9em',
                }}
              >
                {active ? "Ao desativá-lo, ele deixará de ser aplicado e não afetará mais os resultados." : "Ao ativá-lo, ele será aplicado e poderá impactar os resultados exibidos."}
              </p> */}
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '40%', marginTop: '3%' }} >
                <CustomButton
                text= {"Cancelar" }
                color={palette.lightVermelho}
                hoverColor="#E55656"
                onClick={handleCancel}

                />
                <CustomButton
                text={'Sim'}
                color={palette.darkAzul}
                hoverColor="#172B6C"
                type="submit"
                onClick={onSubmit}
                />
                 </div>
            </div>
          </Box>
        </Modal>
      </div>
    </ThemeProvider>
  );
}
